import React,{useState, useEffect} from 'react';
import axios from 'axios';
import {databaseUrl} from '../../server/server.js';
import { useLocation } from 'react-router-dom';
import { databaseNoport } from '../../server/server.js';
import { Button } from '@mui/material';
import axiosInstance from '../../server/axios.js';

const VisitorCheck = () => {
    const location = useLocation();
    const id = location.search.split('=');
    const searchid = Number(id[1]);
    const OrderCheckList = async() => {
        const OrderInfo = await axiosInstance.get(`/orderboard/orderinfo?searchid=${searchid}`);
            console.log(OrderInfo.data);
      }
    useEffect(()=>{OrderCheckList();},[])







}
export default VisitorCheck;